import { Form, Input, Table } from "antd";
import axios from "axios";
import React, { useEffect } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { serverUrl } from "../../../../../nestserver";
import BackButton from "../../../../../components/buttons/BackButton";

const AdminMontessoriViewTemplate = () => {
  const { id } = useParams();
  const [form] = Form.useForm();

  const fetchTemplate = async () => {
    const res = await axios({
      method: "get",
      url: `${serverUrl}/montessori-progress-card-template/${id}`,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  };

  const { data, isSuccess } = useQuery(
    ["montessori-admin-template-view", id],
    fetchTemplate,
    { enabled: !!id },
  );

  useEffect(() => {
    if (isSuccess && data?.result?.data) {
      form.setFieldsValue({
        title: data.result.data.name,
        year: data.result.data.academic_year,
        class: data.result.data.class?.name,
      });
    }
  }, [isSuccess, data, form]);

  const template = data?.result?.data;

  return (
    <div>
      <div className="p-8">
        <div className="bg-white p-10 rounded-2xl shadow-sm border border-gray-100">
          <div className="form-header">
            <div className="flex justify-between items-center mb-8 border-b pb-6">
              <h2 className="text-2xl font-bold text-gray-800">
                Template Details
              </h2>
              <BackButton />
            </div>
            <div className="pt-4 w-1/2">
              <Form
                form={form}
                name="admin-view-template"
                autoComplete="off"
                layout="vertical"
              >
                <Form.Item label="Template Name" name="title">
                  <Input
                    placeholder="Template name"
                    readOnly
                    className="capitalize font-semibold text-gray-700"
                  />
                </Form.Item>
                <Form.Item name="year" label="Academic Year">
                  <Input readOnly />
                </Form.Item>
                <Form.Item label="Class" name="class">
                  <Input readOnly />
                </Form.Item>
              </Form>
            </div>

            <div className="mt-4">
              <div className="font-semibold text-gray-800 text-lg mb-4">
                Active Terms
              </div>
              <div className="flex gap-4 mb-8">
                {template?.active_terms?.length > 0 ? (
                  template.active_terms.map((term, index) => (
                    <div
                      key={index}
                      className="bg-orange-100 text-orange-700 px-5 py-2 rounded-full font-bold text-sm shadow-sm border border-orange-200"
                    >
                      {term}
                    </div>
                  ))
                ) : (
                  <div className="text-gray-400 italic bg-gray-50 px-4 py-2 rounded-lg">
                    No terms configured
                  </div>
                )}
              </div>

              <div className="mt-8">
                <div className="font-semibold text-gray-800 text-lg mb-6 py-4 border-t border-gray-100">
                  Categories & Skills
                </div>
                <div className="space-y-12">
                  {template?.domains?.map((domain, i) => (
                    <div
                      key={i}
                      className="border border-gray-200 rounded-xl overflow-hidden shadow-md transition-shadow hover:shadow-lg"
                    >
                      <div className="bg-orange-50 px-6 py-4 border-b border-gray-200 flex items-center justify-between">
                        <span className="font-bold text-orange-800 text-base capitalize">
                          {domain.name}
                        </span>
                        <span className="text-xs bg-orange-100 text-orange-700 px-3 py-1 rounded-full font-semibold">
                          {domain.milestones?.length || 0} Skills
                        </span>
                      </div>
                      <Table
                        columns={[
                          {
                            title: "S.No",
                            key: "sno",
                            width: 80,
                            align: "center",
                            render: (text, record, index) => (
                              <span className="font-medium text-gray-500">
                                {index + 1}
                              </span>
                            ),
                          },
                          {
                            title: "Skill Description",
                            dataIndex: "description",
                            key: "description",
                            render: (text) => (
                              <div className="text-sm text-gray-700 font-medium py-1">
                                {text}
                              </div>
                            ),
                          },
                        ]}
                        dataSource={domain.milestones || []}
                        pagination={false}
                        rowKey={(record, j) => `${i}-${j}`}
                        size="middle"
                        className="custom-table"
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminMontessoriViewTemplate;
